import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="m9.656 13.218 5.995-5.996a4.202 4.202 0 0 0 1.24-2.991c0-1.13-.44-2.193-1.24-2.992a4.206 4.206 0 0 0-2.99-1.24c-1.13 0-2.193.442-2.992 1.24L2.676 8.233A5.677 5.677 0 0 0 1 12.279c0 1.528.594 2.965 1.676 4.045A5.68 5.68 0 0 0 6.721 18a5.68 5.68 0 0 0 4.046-1.676l5.32-5.32a1 1 0 0 0-1.415-1.413L9.353 14.91a3.724 3.724 0 0 1-5.263 0 3.724 3.724 0 0 1 0-5.263l6.993-6.993a2.232 2.232 0 0 1 3.154 0c.87.87.87 2.284 0 3.154l-5.995 5.995a.741.741 0 0 1-1.263-.522.73.73 0 0 1 .217-.522l4.292-4.293a.999.999 0 1 0-1.414-1.414l-4.29 4.292-.002-.001a2.72 2.72 0 0 0-.803 1.938c0 .73.285 1.419.803 1.937a2.73 2.73 0 0 0 1.937.8c.701 0 1.403-.267 1.937-.8Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path fill="currentColor" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
